import React, { useEffect } from 'react';
import { Container } from './styles';
import Loja from '~/components/Loja';
import { Row, Col } from 'react-bootstrap';
import { InputDate, InputSelect } from '~/components/NovosInputs';
import { useLiberacaoTesouraria } from './LiberacaoTesourariaContext';
import ContainerButtonCapa from './components/ContainerButtonCapa';

import { MdCheck, MdPrint } from 'react-icons/md';

import { AiOutlineMinusCircle } from 'react-icons/ai';
import { DataGridComponent } from './components/DataGridComponent';

import Totalizadores from './components/Totalizadores';
import Tippy from '@tippyjs/react';
import { HotKeys, configure } from 'react-hotkeys';
import { useQueryClient } from 'react-query';
import FormDefault from '~/components/FormDefault';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

export const LiberacaoTesourariaContent: React.FC = () => {
  const {
    handleLoja,
    handleChangeLojaAndDate,
    handledisableCaixa,
    handleChangeCaixa,
    handleDelete,
    handleImprimir,
    handleValidar,
    handleGetTurnos,

    lojaConferencia,
    disableInputs,
    optionsPdv,
    disableCaixa,
    optionsOperador,
    disableOperador,
    optionsTurno,
    disableTurno,
    disableButtonValidar,
    disabledButtonImprimir,

    setValue,
    register,
    control,
    errors,
    focusInput,
    setFocusInput,
  } = useLiberacaoTesouraria();

  const queryClient = useQueryClient();

  configure({
    ignoreTags: ['input', 'select', 'textarea'],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ignoreEventsCondition(keyEvent: KeyboardEvent) {
      return false;
    },
  });

  const keyMap = {
    hkSalvar: 'ctrl+alt+s',
    hkDelete: 'ctrl+alt+d',
  };

  const validaTelaAtalho = () => {
    const cod_tela_active: any = queryClient.getQueryData(`cod_tela_active`);
    if (cod_tela_active) {
      if (cod_tela_active.cod_tela === 280) {
        return true;
      }
    }

    return false;
  };

  const keyHandlers = {
    hkSalvar: () => {
      const validaAtalho = validaTelaAtalho();
      if (validaAtalho) {
        if (!disableButtonValidar) {
          handleValidar();
        }
      }
    },
    hkDelete: () => {
      const validaAtalho = validaTelaAtalho();
      if (validaAtalho) {
        if (!disableButtonValidar) {
          handleDelete();
        }
      }
    },
  };

  const focusInputByName = (inputName: string) => {
    const inputElement = document.querySelector<HTMLInputElement>(
      `input[name="${inputName}"]`,
    );
    if (inputElement) {
      inputElement.click();
      inputElement.focus();
    }
  };

  useEffect(() => {
    if (focusInput) {
      focusInputByName('dta_mov');
    }
    setFocusInput(false);
  }, [focusInput]);

  return (
    <HotKeys id="hotkeys" keyMap={keyMap} handlers={keyHandlers} tabIndex={-1}>
      <Container>
        {/* <Title>Liberação da Tesouraria</Title>
        <SeparatorLine /> */}
        <FormDefault
          codTela={280}
          title="Liberação da Tesouraria"
          onSave={() => Promise.resolve()}
          onCancel={() => []}
          onClearFields={() => []}
          onNew={() => []}
          onDelete={() => []}
          onReturnSearch={() => []}
          isDelete={false}
          isNew={false}
          isCancel={false}
          isClear={false}
          isSave
          customButtons={
            <div style={{ display: 'inline-flex', gap: '8px' }}>
              <Tippy
                placement="bottom"
                content="CTRL + ALT + D"
                arrow
                animation="scale"
                appendTo={() => document.body}
                trigger="mouseenter focus"
                zIndex={9999}
              >
                <span
                  style={{ display: 'inline-flex', alignItems: 'stretch' }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <CustomButtonNovo
                    disabled={disableButtonValidar}
                    onClick={() => handleDelete()}
                    icon={AiOutlineMinusCircle}
                    variant="error"
                    width="10.3125rem"
                  >
                    Excluir Tesouraria
                  </CustomButtonNovo>
                </span>
              </Tippy>
              <CustomButtonNovo
                disabled={disabledButtonImprimir}
                onClick={() => handleImprimir()}
                style={{ backgroundColor: '#808080' }}
                icon={MdPrint}
              >
                Imprimir
              </CustomButtonNovo>
              <Tippy
                placement="bottom"
                content="CTRL + ALT + S"
                arrow
                animation="scale"
                appendTo={() => document.body}
                trigger="mouseenter focus"
                zIndex={9999}
              >
                <span
                  style={{ display: 'inline-flex', alignItems: 'stretch' }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <CustomButtonNovo
                    disabled={disableButtonValidar}
                    onClick={() => handleValidar()}
                    icon={MdCheck}
                    variant="confirm"
                  >
                    Validar
                  </CustomButtonNovo>
                </span>
              </Tippy>
            </div>
          }
        >
          <Row>
            <Col md={12} sm={12}>
              <Loja
                onChange={(val: any) => {
                  handleLoja(val);
                  setValue('lojas', val);
                  handleChangeLojaAndDate();
                }}
                selectedLoja={lojaConferencia}
                isDisabled={disableInputs}
              />
            </Col>
          </Row>
          <Row>
            <Col md={2} sm={12}>
              <InputDate
                label="Data Mov."
                placeholder=""
                name="dta_mov"
                register={register}
                isError={!!errors.dta_mov}
                control={control}
                onBlur={() => {
                  handleChangeLojaAndDate();
                }}
                onChange={(event: any) => {
                  setValue('dta_mov', event.target?.value);
                  handledisableCaixa(false);
                }}
                disabled={disableInputs}
              />
            </Col>

            <Col md={2} sm={12}>
              <InputSelect
                label="Caixa"
                placeholder="Selecione..."
                name="caixa"
                register={register}
                isError={!!errors.caixa}
                control={control}
                options={optionsPdv}
                changeSelected={(selected) => {
                  setValue('caixa', selected);

                  handleChangeCaixa();
                }}
                isDisabled={disableCaixa}
              />
            </Col>

            <Col md={6} sm={12}>
              <InputSelect
                label="Operador"
                placeholder="Selecione..."
                name="operador"
                register={register}
                isError={!!errors.operador}
                control={control}
                options={optionsOperador}
                changeSelected={(selected) => {
                  setValue('operador', selected);
                  handleGetTurnos();
                }}
                isDisabled={disableOperador}
              />
            </Col>

            <Col md={2} sm={12}>
              <InputSelect
                label="Turno"
                placeholder="Selecione..."
                name="turno"
                register={register}
                isError={!!errors.turno}
                control={control}
                options={optionsTurno}
                changeSelected={(selected) => setValue('turno', selected)}
                isDisabled={disableTurno}
              />
            </Col>
          </Row>

          <ContainerButtonCapa />
          <DataGridComponent />

          <br />
          <Totalizadores />
          <br />
        </FormDefault>
      </Container>
    </HotKeys>
  );
};
